
import { defineComponent } from "@vue/composition-api";
import BaseLayout from "@/components/shared/layout/BaseLayout.vue";

export default defineComponent({
  name: "TheHelpPage",
  components: { BaseLayout },
  setup() {
    const openEmailWindow = (email: string): void => {
      window.open(`mailto:${email}?subject=Kundeservice`, "_self");
    };

    return {
      openEmailWindow,
      navigateBack: () => history.back(),
    };
  },
});
